import { render, staticRenderFns } from "./BoardMenu.vue?vue&type=template&id=ff63857e&scoped=true"
import script from "./BoardMenu.vue?vue&type=script&lang=js"
export * from "./BoardMenu.vue?vue&type=script&lang=js"
import style0 from "./BoardMenu.vue?vue&type=style&index=0&id=ff63857e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff63857e",
  null
  
)

export default component.exports